import React, { PureComponent } from "react";
import FieldContainer from "../components/FieldContainer";
import { hasOriginalData } from "../utils";
import { getEmailDomainRegex, validateEmail } from "../utils/emailUtils";

export default class Emailfield extends PureComponent {
  static defaultProps = {
    value: "",
    required: false,
  };

  render() {
    const {
      id,
      label,
      placeholder,
      name,
      value,
      onChange,
      required,
      disabled,
      locked,
      strings,
      whitelist,
      blacklist,
    } = this.props;
    if (disabled && !value) return null; // Hide disabled field
    const { domains: whitelistedDomains } = whitelist || {};
    const { domains: blacklistedDomains } = blacklist || {};
    const domainRegex = getEmailDomainRegex({ whitelist: whitelistedDomains, blacklist: blacklistedDomains });
    const { isValid, errors } = validateEmail(value, domainRegex, strings);
    return (
      <FieldContainer {...this.props}>
        <input
          id={id}
          className="af-email-field"
          name={name}
          type="email"
          placeholder={placeholder || label}
          value={value}
          required={required}
          readOnly={disabled || (locked && hasOriginalData(name))}
          onChange={(e) => onChange(name, e.target.value)}
          pattern={domainRegex}
        />
        {!!value && !isValid && (
          <div className="af-message af-message--error">
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              {errors.map((e) => (
                <li key={e}>{e}</li>
              ))}
            </ul>
          </div>
        )}
      </FieldContainer>
    );
  }
}
